/** Same value as the react-query default retry count. */
export const MAX_QUERY_RETRIES = 3;

const getHttpStatus = (error: unknown) =>
  (error as { _response?: { status?: number } } | null)?._response?.status;

/**
 * Default retry policy of the queries: client errors (4xx) fail right away,
 * other errors are retried up to MAX_QUERY_RETRIES times.
 */
export const shouldRetryQuery = (
  failureCount: number,
  error: unknown,
): boolean => {
  const status = getHttpStatus(error);
  if (status !== undefined && status >= 400 && status < 500) {
    return false;
  }

  return failureCount < MAX_QUERY_RETRIES;
};
